import * as React from 'react';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import generateLinkStyle from 'owa-component-styling-utils/lib/utils/colorSchemesToStyles/generateLinkStyle';
import { Icon } from '@fluentui/react/lib/Icon';
import { Link } from '@fluentui/react/lib/Link';
import { observer } from 'mobx-react-lite';
import { OnlineMeetingProviderType } from '../utils/OnlineMeetingProviderType';
import {
    getIconFromProviderName,
    getJoinMeetingLabelFromProviderName,
} from '../utils/onlineMeetingHelper';

let styles = require('./OnlineMeetingLink.scss');
const classNames = require('classnames/bind').bind(styles);

export interface OnlineMeetingLinkProps {
    event: CalendarEvent;
    calendarColorScheme: ColorScheme;
    onLinkClickedCallback?: () => void;
    hideIcon?: boolean;
    joinOnlineLinkContainerClassName?: string;
    joinOnlineLinkClassName?: string;
}

/**
 * This is the 'Join Online Meeting' link control.
 */
const OnlineMeetingLink = observer(function OnlineMeetingLink(props: OnlineMeetingLinkProps) {
    let {
        event,
        calendarColorScheme,
        onLinkClickedCallback,
        hideIcon,
        joinOnlineLinkContainerClassName,
        joinOnlineLinkClassName,
    } = props;

    let provider = event.OnlineMeetingProvider as OnlineMeetingProviderType;

    let icon = getIconFromProviderName(provider);
    let onlineMeetingButtonLabel = getJoinMeetingLabelFromProviderName(provider);

    return (
        <div
            className={classNames(
                styles.joinOnlineLinkContainer,
                joinOnlineLinkContainerClassName
            )}>
            {!hideIcon && (
                <Icon
                    iconName={icon}
                    className={styles.onlineMeetingIcon}
                    style={{
                        color: calendarColorScheme.calPrimary,
                    }}
                />
            )}
            <Link
                className={classNames(styles.joinOnlineLink, joinOnlineLinkClassName)}
                href={event.OnlineMeetingJoinUrl}
                disabled={!event.OnlineMeetingJoinUrl}
                onClick={onLinkClickedCallback}
                target="_blank"
                styles={generateLinkStyle(calendarColorScheme)}>
                {onlineMeetingButtonLabel}
            </Link>
        </div>
    );
});
export default OnlineMeetingLink;
